export default function AddEmpty({ onClick }: { onClick: Function }) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e?.preventDefault();
        if (onClick) {
          onClick();
        }
      }}
      className="flex flex-col justify-center items-center bg-[#fefefee8] h-full min-h-[180px] relative w-full rounded-lg border-2 border-dashed border-gray-300 text-center hover:border-gray-400 focus:outline-none p-4"
    >
      <div className="flex flex-row items-center justify-center w-fit relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-10 h-10 sm:w-14 sm:h-14 text-gray-400"
        >
          <path
            fillRule="evenodd"
            d="M3.75 4.5a.75.75 0 0 1 .75-.75h.75c8.284 0 15 6.716 15 15v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75C18 11.708 12.292 6 5.25 6H4.5a.75.75 0 0 1-.75-.75V4.5Zm0 6.75a.75.75 0 0 1 .75-.75h.75a8.25 8.25 0 0 1 8.25 8.25v.75a.75.75 0 0 1-.75.75H12a.75.75 0 0 1-.75-.75v-.75a6 6 0 0 0-6-6H4.5a.75.75 0 0 1-.75-.75v-.75Zm0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
            clipRule="evenodd"
          />
        </svg>

        <div className="absolute -bottom-1 -right-1 rounded-full p-0.5 bg-white text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="3"
            stroke="currentColor"
            className="w-4 h-4 sm:w-5 sm:h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
        </div>
      </div>

      <span className="mt-2 block text-xs sm:text-sm lg:text-base font-semibold text-gray-400 text-center">
        Create a new AI Social Invite
      </span>
    </button>
  );
}
